import ActivityLogsUserSalesPage from "../../../component/users/sales/ActivityLogsUserSales"

 
 
function ActivityLogsUserSales() {

  return (
    <div className="page-body"><ActivityLogsUserSalesPage/></div>
  )
}

export default ActivityLogsUserSales